import { render, staticRenderFns } from "./Ban.vue?vue&type=template&id=e27329c6&scoped=true"
import script from "./Ban.vue?vue&type=script&lang=js"
export * from "./Ban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27329c6",
  null
  
)

export default component.exports